<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mt-5">
        <ul class="heading-ul mb-5">
          <li>
            <router-link :to="{ path: '/chart_of_accounts' }" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h4>{{ $t("accounting.label.viewglaccount") }}</h4>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      v-if="accountViewData.usage.value == 'HEADER'"
                      color="primary"
                      icon-pack="feather"
                      icon="icon-plus"
                      class="truncate"
                      @click="handleAddSubledger()"
                      size="small"
                      >{{ $t("accounting.label.subledgeraccount") }}</vs-button
                    >
                    <vs-button
                      v-if="accountViewData.disabled == false"
                      color="primary"
                      icon-pack="feather"
                      icon="icon-lock"
                      class="truncate"
                      @click="handleDisable()"
                      size="small"
                      >{{ $t("accounting.label.disable") }}</vs-button
                    >
                    <vs-button
                      v-if="accountViewData.disabled == true"
                      color="primary"
                      icon-pack="feather"
                      icon="icon-unlock"
                      class="truncate"
                      @click="handleEnable()"
                      size="small"
                      >{{ $t("accounting.label.enable") }}</vs-button
                    >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData()"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteGLAccountPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("accounting.label.glcode") }}</b>
                </td>
                <td>{{ accountViewData.glCode }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.accounttype") }}</b>
                </td>
                <td>{{ accountViewData.type.value }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.accountusage") }}</b>
                </td>
                <td>{{ accountViewData.usage.value }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.manualentriesallowed") }}</b>
                </td>
                <td>{{ accountViewData.manualEntriesAllowed }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("accounting.label.description") }}</b>
                </td>
                <td>{{ accountViewData.description }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteGLAccountPopup"
      title="GL Account"
      @deletePressed="deleteGLAccount()"
      @cancelPressed="deleteGLAccountPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      deleteGLAccountPopup: false,
    };
  },

  computed: {
    ...mapState({
      accountViewData: (state) => state.accounting.accountTemplateById,
    }),
  },
  methods: {
    async getTemplateDataById() {
      try {
        await this.$store.dispatch(
          "accounting/accountTemplateDataByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async handleDisable() {
      const payload = {
        id: this.id,
        data: {
          disabled: true,
        },
      };
      try {
        await this.$store.dispatch("accounting/updateGLAccountAction", payload);
        await this.getTemplateDataById();
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating entity:", e);
      }
    },
    async handleEnable() {
      const payload = {
        id: this.id,
        data: {
          disabled: false,
        },
      };
      try {
        await this.$store.dispatch("accounting/updateGLAccountAction", payload);
        await this.getTemplateDataById();
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating entity:", e);
      }
    },
    async handleAddSubledger() {
      this.$router.push({
        name: `Create Account`,
        query: {
          subledger: true,
          parent: this.accountViewData.id,
          accType: this.accountViewData.type.id,
        },
      });
    },
    async deleteGLAccount() {
      try {
        this.deleteGLAccountPopup = false;
        await this.$store.dispatch("accounting/deleteGLAccountAction", this.id);
        this.$router.push({ path: `/chart_of_accounts` });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editData() {
      this.$router.push(`/chart_of_accounts/edit_account/${this.id}`);
    },
  },
  filters: {},
  async created() {
    this.id = this.$route.params.id;
    await this.getTemplateDataById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
